import { createFileRoute } from '@tanstack/react-router'
import { SubTabsPane } from './-components/dev/transition-playground'

// Gamma: a light member of the item pager that hosts its OWN nested tab pager — the two-nested-
// transition-tabs case, inside the stacked screen (see dev-resources.transitions.tsx).
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/gamma')({
  component: () => <SubTabsPane title="Gamma" scope="/dev-resources/transitions/one/item/gamma" />,
})
